import { subscribe } from '../../common/errors/sagas';
import { notificationError } from '../../common/errors/notificationTypes';

const pre = 'DAILYBATCHHIST/';

export const SET_GRID_SORTS = `${pre}SET_GRID_SORTS`;

export const SET_DEFAULT_FILTERS = `${pre}SET_DEFAULT_FILTERS`;
export const SET_RUNDATE = `${pre}SET_RUNDATE`;
export const SET_DATE_TO = `${pre}SET_DATE_TO`;
export const SET_DATE_FROM = `${pre}SET_DATE_FROM`;

export const DAILY_BATCH_HIST_LOADED = `${pre}DAILY_BATCH_HIST_LOADED`;
export const SET_DAILY_BATCH_HIST_LOADING = `${pre}SET_DAILY_BATCH_HIST_LOADING`;
export const SET_DAILY_BATCH_HIST_INITIALISED = `${pre}SET_DAILY_BATCH_HIST_INITIALISED`;
export const GET_DAILY_BATCH_HISTORY = `${pre}GET_DAILY_BATCH_HISTORY`;
export const GET_DAILY_BATCH_HIST_SUCCESS = `${pre}GET_DAILY_BATCH_HIST_SUCCESS`;
export const GET_DAILY_BATCH_HIST_FAILED = `${pre}GET_DAILY_BATCH_HIST_FAILED`;
export const REFRESH_DAILY_BATCH_HIST = `${pre}REFRESH_DAILY_BATCH_HIST`;
subscribe(GET_DAILY_BATCH_HIST_FAILED, 'There was an error retrieving daily batch history', notificationError);

export const setGridSorts = (gridId, sorting) => ({
    type: SET_GRID_SORTS,
    gridId,
    sorting
});
export const dailyBatchHistConnected = search => ({
    type: DAILY_BATCH_HIST_LOADED,
    search
});

export const setDailyBatchHistLoading = loading => ({
    type: SET_DAILY_BATCH_HIST_LOADING,
    loading
});

export const setDailyBatchHistInitialised = initialised => ({
    type: SET_DAILY_BATCH_HIST_INITIALISED,
    initialised
});

export const getDailyBatchHistory = () => ({
    type: GET_DAILY_BATCH_HISTORY
});

export const getDailyBatchHistSuccess = result => ({
    type: GET_DAILY_BATCH_HIST_SUCCESS,
    result
});

export const getDailyBatchHistFailed = error => ({
    type: GET_DAILY_BATCH_HIST_FAILED,
    error
});

export const refreshDailyBatchHist = () => ({
    type: REFRESH_DAILY_BATCH_HIST    
});

export const setDefaultFilters = filters => ({
    type: SET_DEFAULT_FILTERS,
    filters
});

export const setRunDate = date => ({
    type: SET_RUNDATE,
    date
});
export const setDateFrom = date => ({
    type: SET_DATE_FROM,
    date
});
export const setDateTo = date => ({
    type: SET_DATE_TO,
    date
});


